import { getProgressionDrillById } from '../data/progression/drills';
import { getLessonFlowForSkill } from '../data/progression/lessonFlows';
import { getProgressionSkillById, getProgressionSkillsForSport } from '../data/progression/skills';
import { getSkillTracksForSport } from '../data/progression/skillTracks';
import { LESSON_STAGE_KEYS } from './progressionConstants';

function formatStageTitle(stageKey) {
  return String(stageKey || '')
    .replace(/_/g, ' ')
    .trim()
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function buildSkillDetailViewModel({ sport = '', selectedSkillId = '', roadmap = null } = {}) {
  if (!sport || !selectedSkillId) return null;

  const skill = getProgressionSkillById(selectedSkillId);
  if (!skill) return null;

  const track = getSkillTracksForSport(sport).find((item) => item.trackId === skill.trackId) || null;
  const roadmapSkill = roadmap?.tracks
    ?.flatMap((item) => item.skills.map((trackSkill) => ({ ...trackSkill, trackId: item.trackId, trackName: item.name })))
    .find((item) => item.skillId === selectedSkillId);

  const allSportSkills = getProgressionSkillsForSport(sport);
  const prerequisiteSkills = (skill.prerequisites || [])
    .map((id) => allSportSkills.find((item) => item.skillId === id))
    .filter(Boolean);
  const nextSkills = (skill.nextSkillIds || [])
    .map((id) => allSportSkills.find((item) => item.skillId === id))
    .filter(Boolean);
  const lessonFlow = getLessonFlowForSkill(selectedSkillId);
  const lessonFlowStages = lessonFlow
    ? LESSON_STAGE_KEYS.map((stageKey) => ({
        stage: stageKey,
        title: formatStageTitle(stageKey),
        drills: (lessonFlow.stages?.[stageKey] || [])
          .map((drillId) => getProgressionDrillById(drillId))
          .filter(Boolean),
      }))
    : [];

  return {
    skillId: skill.skillId,
    name: skill.name,
    description: skill.description || '',
    trackName: track?.name || roadmapSkill?.trackName || 'Core Progression',
    status: roadmapSkill?.status || 'available',
    prerequisiteSkills,
    nextSkills,
    hasPrerequisites: prerequisiteSkills.length > 0,
    hasNextSkills: nextSkills.length > 0,
    hasLessonFlow: lessonFlowStages.length > 0,
    lessonFlowTitle: `Lesson flow for ${skill.name}`,
    lessonFlowStages,
    lessonFlowEmptyText: 'A staged lesson flow has not been added for this skill yet.',
  };
}
